var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.108 28.689c-1.644-.95-3.506-1.238-5.346-1.304-1.534-.044-3.835-1.06-3.835-3.887 0-2.099 1.687-3.8 3.856-3.888 1.84-.066 3.703-.353 5.346-1.303 4.667-2.717 6.245-8.725 3.572-13.408C40.984.216 35.024-1.396 30.358 1.32c-3.024 1.745-4.864 4.992-4.864 8.504 0 1.9.679 3.644 1.533 5.279.723 1.37 1.074 3.91-1.38 5.345-1.84 1.06-4.14.398-5.28-1.458-.964-1.568-2.125-3.026-3.768-3.975-4.667-2.74-10.627-1.127-13.3 3.578s-1.095 10.69 3.572 13.408a9.693 9.693 0 0 0 9.728 0c1.643-.95 2.804-2.408 3.768-3.976.789-1.281 2.782-2.916 5.28-1.458 1.84 1.06 2.41 3.402 1.38 5.345-.854 1.613-1.533 3.38-1.533 5.28 0 5.411 4.36 9.807 9.728 9.807 5.367 0 9.727-4.396 9.727-9.807a9.772 9.772 0 0 0-4.841-8.504Z",
    fill: "url(#33_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "33_svg__a",
    x1: 14.109,
    y1: 7.209,
    x2: 46.689,
    y2: 39.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg33);
export default __webpack_public_path__ + "static/media/33.978bf62b061245c99a560c737cd74a3e.svg";
export { ForwardRef as ReactComponent };